import { render, staticRenderFns } from "./TakeOrderNew.vue?vue&type=template&id=792cd6d6&"
import script from "./TakeOrderNew.vue?vue&type=script&lang=js&"
export * from "./TakeOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./TakeOrderNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports